export default __webpack_public_path__ + "static/media/maize.24ce351c.png";